import { getSvgSelected, getSvgNonSelected, getSvgSomeSelected } from 'utils/domElements';

const getHeaderCheckboxSvgHtmlForState = (tableId, colId, isChecked, areAllChecked) => {
    if (!tableId || !colId) return null;

    if (areAllChecked) {
        return getSvgSelected(tableId, colId);
    }
    if (isChecked) {
        return getSvgSomeSelected(tableId, colId);
    }
    return getSvgNonSelected(tableId, colId);
};

export function getHeaderCheckboxSvgHtml(tableId, colId, context) {
    if (!tableId || !colId) return null;

    const checkedRowsList = context?.checkboxData?.[colId]?.rows
        ? Object.keys(context.checkboxData[colId].rows).filter(
              (current) => context.checkboxData[colId].rows[current],
          )
        : [];
    const isChecked = checkedRowsList.length > 0;
    const areAllChecked = context?.checkboxData?.[colId]?.areAllChecked || false;

    return getHeaderCheckboxSvgHtmlForState(tableId, colId, isChecked, areAllChecked);
}

export function refreshHeaderCheckbox(tableId, colId, context) {
    const tableElement = document.getElementById(tableId);
    if (!tableElement) return false;

    const headerCell = tableElement.querySelector(`.ag-header-cell[col-id="${colId}"]`);
    if (!headerCell) return false;

    const svgContainer = headerCell.querySelector('.w5-header-cell-checkbox__svg-container');
    if (!svgContainer) return false;

    const svgHtml = getHeaderCheckboxSvgHtml(tableId, colId, context);
    if (!svgHtml) return false;

    if (svgContainer.innerHTML !== svgHtml) {
        svgContainer.innerHTML = svgHtml;
    }

    return true;
}

export default function HeaderCellCheckbox(params) {
    const { checkbox, column, context } = params;
    if (!checkbox) return null;

    let colId = column.colId;
    let checkedRowsList = [];

    if (context?.checkboxData?.[colId]?.rows) {
        checkedRowsList =
            Object.keys(context.checkboxData[colId].rows).filter(
                (current) => context.checkboxData[colId].rows[current],
            ) || [];
    }

    const isDisabled = (checkbox.isDisabled && checkbox.isDisabled(colId)) || false;
    let isChecked = checkedRowsList.length > 0 || false;
    let areAllChecked = false;

    if (context.checkboxData?.[colId]) {
        areAllChecked = context.checkboxData?.[colId]?.areAllChecked || false;
    }

    const tableId = context?.tableId || '';

    const svg = getSvg(isChecked, areAllChecked, tableId, colId);

    const cell = document.createElement('div');
    cell.classList.add('w5-header-cell-checkbox');
    if (isDisabled) cell.classList.add('w5-header-cell-checkbox--disabled');

    if (!params.useDragColumns && params.useDragRows && params?.checkbox?.onClick) {
        cell.classList.add('w5-header-cell-checkbox__align-with-rows');
    }

    if (!svg) return cell;

    if (checkbox.onClick) {
        svg.addEventListener(
            'click',
            handleOnChange(
                cell,
                svg,
                colId,
                isChecked,
                areAllChecked,
                isDisabled,
                checkbox.onClick,
                context,
                column,
                tableId,
            ),
        );
    }

    cell.appendChild(svg);

    return cell;
}

const getSvg = (isChecked, areAllChecked, tableId, colId) => {
    const svgContainer = document.createElement('div');
    svgContainer.classList.add('w5-header-cell-checkbox__svg-container');

    const svgHtml = getHeaderCheckboxSvgHtmlForState(tableId, colId, isChecked, areAllChecked);
    if (!svgHtml) return null;

    svgContainer.innerHTML = svgHtml;
    return svgContainer;
};

const handleOnChange =
    (cell, svg, colId, isChecked, areAllChecked, isDisabled, onClick, context, column, tableId) =>
    (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (isDisabled) return;

        if (!isChecked && !areAllChecked) {
            isChecked = true;
            areAllChecked = true;
        } else if (isChecked && !areAllChecked) {
            isChecked = false;
        } else if (isChecked && areAllChecked) {
            isChecked = false;
            areAllChecked = false;
        }

        svg.remove();
        const newSvg = getSvg(isChecked, areAllChecked, tableId, colId);
        if (!newSvg) return null;

        newSvg.addEventListener(
            'click',
            handleOnChange(
                cell,
                newSvg,
                colId,
                isChecked,
                areAllChecked,
                isDisabled,
                onClick,
                context,
                column,
                tableId,
            ),
        );
        cell.appendChild(newSvg);

        onClick({ colId, boolean: areAllChecked, context, column });
    };
